import { ICON_COLOR } from '@zep-us/zus';
import { ClockIcon, CouponFillIcon } from '@zep-us/zus-icons';
import { type UserVoucherRes } from '@/api/gen/_model/userVoucherRes';
import { confirmDialog } from '@/ui_v3';
type VoucherTrialStartDialogCopy = {
  cancelText: string;
  confirmText: string;
  description: string;
  expiresAt: string;
  title: string;
  voucherLabel: string;
};

/**
 * 시안(Figma 28913:54417) — "2027. 01. 23 오후 3시까지 사용 가능".
 *
 * 보관함의 `formatDateByTimezone` 은 분까지 24시간제로 찍어서("2027. 1. 23. 15:00")
 * 시안과 다르다. 여기서는 시각을 시 단위 오전/오후로만 말한다.
 */
export const formatVoucherExpiry = (expiryDate: string, timezone: string, locale: string) => new Date(expiryDate).toLocaleString(locale, {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: 'numeric',
  hour12: true,
  timeZone: timezone || 'Asia/Seoul'
});

/** 시안의 `.플랜관리/이용권/카드`. */
const VoucherCard = ({
  copy,
  voucher
}: {
  copy: Pick<VoucherTrialStartDialogCopy, 'expiresAt' | 'voucherLabel'>;
  voucher: UserVoucherRes;
}) => <div className="flex w-full items-center gap-sm rounded-md border border-alternative px-lg py-md" data-sentry-component="VoucherCard" data-sentry-source-file="voucherTrialStartDialog.tsx">
    <span className="flex size-[40px] shrink-0 items-center justify-center rounded-full bg-yellow-100">
      <CouponFillIcon size="sm" fill={ICON_COLOR.cautionary} data-sentry-element="CouponFillIcon" data-sentry-source-file="voucherTrialStartDialog.tsx" />
    </span>
    <div className="flex min-w-0 flex-1 flex-col gap-4xs">
      {/* 시안: 캠페인명↔이용권명 4px, 그 묶음↔만료일 2px */}
      <div className="flex min-w-0 flex-col gap-3xs">
        {voucher.campaignName && <p className="truncate text-caption-lg-medium text-alternative">
            {voucher.campaignName}
          </p>}
        <p className="truncate text-body-lg-bold text-default">
          {copy.voucherLabel}
        </p>
      </div>
      <span className="flex items-center gap-3xs text-caption-lg-medium text-alternative">
        <ClockIcon size="2xs" data-sentry-element="ClockIcon" data-sentry-source-file="voucherTrialStartDialog.tsx" />
        {copy.expiresAt}
      </span>
    </div>
  </div>;

/**
 * FREE 헤더의 「2주 PRO 체험 시작하기」에서 여는 확인 다이얼로그.
 *
 * @returns 사용자가 「이용권 사용하기」를 눌렀는지
 */
export const openVoucherTrialStartDialog = (voucher: UserVoucherRes, copy: VoucherTrialStartDialogCopy) => confirmDialog.openAsync({
  size: 'sm',
  header: {
    title: copy.title,
    hasCloseButton: true
  },
  body: <div className="flex flex-col gap-sm">
        <p className="text-body-md-regular text-default">{copy.description}</p>
        <VoucherCard copy={copy} voucher={voucher} />
      </div>,
  cancelText: copy.cancelText,
  confirmText: copy.confirmText
});